import React from "react";
import { cn } from "../../../libs/utils";
import { BATCH_STATUS } from "../batchDerived";

const styles = {
  [BATCH_STATUS.CREATED]: "bg-sky-50 text-sky-700",
  [BATCH_STATUS.WIP]: "bg-amber-50 text-amber-700",
  [BATCH_STATUS.HOLD]: "bg-rose-50 text-rose-600",
  [BATCH_STATUS.COMPLETED]: "bg-emerald-50 text-emerald-700",
};

const BatchStatusBadge = ({ status, className }) => (
  <span
    className={cn(
      "inline-flex items-center rounded-md px-2.5 py-1 text-xs font-semibold",
      styles[status] || "bg-slate-100 text-slate-600",
      className
    )}
  >
    {status}
  </span>
);

export default BatchStatusBadge;
